import richTextFragment from '@components/renderers/rich-text.fragment'
import storyCardFragment from '@schema/story-card'

const articleFragment = `
title
headline
slug
cat {
  category
  series
}
audience
author
body {
  ${richTextFragment}
}
sys {
  publishedAt
  firstPublishedAt
}
image {
  contentType
  url
  description
  height
  title
  width
}
video {
  contentType
  url
  description
  height
  title
  width
}
heroVideoEmbed {
  provider
  id
}
heroSource
heroCaption
tagsCollection {
  items {
    label
  }
}
person {
  name
  image {
    url
  }
  position
  organization
  youtube
  coachId
  email
  shortBio
  location
  memberType
}
summary
recommended {
  headline
  articlesCollection {
    total
    items {
      ${storyCardFragment}
    }
  }
}
related {
  headline
  linksCollection {
    items {
      ${storyCardFragment}
    }
  }
}
`
export default articleFragment
